import React, {useEffect, useState} from 'react'
import Multiselect from 'multiselect-react-dropdown';
import {optionsEdibleOils} from './Options';
import Sidebar from './Sidebar';
import { DateInput, StationInput, Val, ByProduct } from './Prices/SugarInput';
// import env from 'react-dotenv'
  export const FarmGradeRates=()=>{
    const [date, setDate] = useState("")
    const [rate, setRate] = useState()
    const [millData, setMillData] = useState()
    const [mill, setMill] = useState({})

    useEffect(()=>{
       // console.log(mill)
    },[mill])

    const getMillData = async () =>{
        const response = await fetch(`${process.env.REACT_APP_API_URL}/get-mills`)
          const data = await response.json()
          setMillData(data)
    }

    useEffect(()=>{
        getMillData()
    },[])

    const handleSubmit =(e)=>{
        e.preventDefault();
        const input = {
        date: date,
        rate: rate,
        province: mill[0].province,
        district: mill[0].district,
        mill_id: mill[0].value,
        mill_name: mill[0].name,

        }
          fetch(`${process.env.REACT_APP_API_URL}/crop-price/farm-gate-single`, {
          
            method: 'POST',
            headers: {
              "Content-Type" : "application/json"
            },
            body: JSON.stringify(input)
          }).then(() => {
           // console.log("New price record(s) added");    
           
          }).catch((err) => {
           // console.log("Unable to add record" + err);
          });
      }
    return(
        <>
        <div className="sidebar">
      <Sidebar/>
      </div>
      <div id="bydrop">
        <h1>Sugar Mill Gate</h1>
        <DateInput x={setDate}></DateInput>
        <ByProduct x={setMill} options={millData} title={"Mill name"}></ByProduct>
        <Val x={setRate} title={"Rate"}></Val>
        <button type="button" class="btn btn-secondary" onClick={handleSubmit}>Submit</button>
      </div>
        </>
    )
  }